// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../imgs/logoBabitaW.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../imgs/wpIcon.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Cardo:wght@700&family=Inter:wght@400;600&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MOVIMENTAÇÂO CARDS */

.homePage{
    /* background-image: url('../imgs/fundoEsq1.jpg'); */
    background-size: cover;
    background-color: #706c6d;
    align-items: center;
    justify-content: center;
}

.homePage .homelogo{
    /* position: relative; */
    min-width: 50%;
    max-width: 80%;
    /* top: 500px; */
    margin-top: 7vh;
    
    margin-bottom: 20px;
    align-self: center;
    aspect-ratio: 350/111;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: contain;
    background-repeat: no-repeat;
    z-index: 7;
    /* filter: drop-shadow(0px 0px 2px var(--white-color)) drop-shadow(0px 0px 2px #0000004a); */
}

.homePage .homelogo.logoAnima{
    animation: logoAnimation 0.5s ease-out 0.5s forwards;
}

.celular{
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 98vh;
    aspect-ratio: 1/2.07;
    background-size: contain;
    background-repeat: no-repeat;
}

.introText{
    width: 90%;
    text-align: center;
    color: var(--white-color);
    font-family: 'Playfair Display', 'serif';
    font-weight: 600;
    margin: 0 auto;
    font-size: 1.3em;
}

.inputFiltro{
    width: 60%;
    height: 45px;
    border-radius: 5px;
    color: var(--escuro-cinza-color);
    margin: 20px 0 20px 0;
    font-family: 'Simonetta', 'serif';
    font-weight: 500;
    text-align: center;
    font-size: 1.5em;
}

.btnBuscar {
    width: 40%;
    background-color: var(--escuro-cinza-color);
    box-shadow: 0 4px 6px 1px #FFFFFF4d;
    color: var(--white-color);
    border: 3px solid var(--white-color);
    padding: 10px 20px;
    font-size: 16px;
    cursor: pointer;
    border-radius: 5px;
    transition: all 0.3s ease;
    font-family: 'Playfair Display', 'serif';
    font-weight: 600;
    text-align: center;
}

.btnBuscar:hover {
    background-color: var(--white-color);
    box-shadow: 0 6px 8px 2px #4a45474d;
    color: var(--escuro-cinza-color);
}

.divisor{
    width: 80%;
    height: 5px;
    border-radius: 15px;
    background-color: var(--white-color);
    margin: 30px 0 15px 0;
}

.vendList{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 85%;
}

.proxVend {
    width: 40%;
    background-color: var(--white-color);
    color: var(--escuro-cinza-color);
    box-shadow: 0 6px 8px 2px #4a45474d;
    border: 3px solid var(--white-color);
    padding: 10px 20px;
    font-size: 16px;
    cursor: pointer;
    border-radius: 5px;
    transition: all 0.3s ease;
    font-family: 'Playfair Display', 'serif';
    font-weight: 600;
    text-align: center;
}

.proxVend:hover {
    background-color: var(--escuro-cinza-color);
    box-shadow: 0 4px 6px 1px #FFFFFF4d;
    color: var(--white-color);
}

.btnBuscarCep{
    margin-top: 15px;
}

.vendedoraCard{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 95%;
    text-align: center;
    color: var(--black-color);
    font-family: 'Playfair Display', 'serif';
    font-weight: 500;
    /*border: 2px dashed var(--white-color);*/
    background-color: var(--white-color);
    border-radius: 5px;
    padding: 15px 5px;
    margin: 15px auto;
}


.vendedoraCard .textInfoRevend{
    width: 80%;
    margin: 2px 0;
    text-align: left;
    padding-left: 10px;
}

.vendedoraCard .textInfoRevend strong{
    color: var(--white-color);
    font-family: 'Cardo', 'serif'
}

.revendFoto{
    width: 20%;
    aspect-ratio: 1/1;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    border-radius: 50%;
}

.wpRevend{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    aspect-ratio: 1/1;
    background-color: #dddddd55;
    color: var(--escuro-cinza-color);
    font-family: 'Playfair Display', 'serif';
    font-weight: 600;
    padding: 6px 6px 6px 6px;
    margin: 20px 0px 5px 0;
    border-radius: 50%;
    border: 2px solid var(--black-color);
    font-size: 1.2em;
    text-decoration: none;
    
}

.wpRevend .wpImage{
    width: 30px;
    aspect-ratio: 1/1;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: contain;
    background-repeat: no-repeat;
}

.topRevend{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 95%;
}

@media(max-width: 767px){

    .homePage .homelogo {
        /* position: absolute; */
        min-width: 50vw;
        max-width: 50vw;
        margin-top: 5px;
    }

    .introText{
        width: 98%;
        font-size: 1.1em;
    }

    .vendList{
        width: 100%;
    }

    .vendedoraCard .textInfoRevend div{
        width: 100%;
    }

    /* .wpRevend{
        width: 80%;
        font-size: 1.0em;
    } */

    .proxVend {
        width: 70%;
    }

}




@keyframes logoAnimation {
    0%{
        transform: translateX(200%)
    }
    100%{
        transform: translateX(0%)
    }
}

`, "",{"version":3,"sources":["webpack://./src/assets/css/homePage.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAGvB;IACI,oDAAoD;IACpD,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;IACxB,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,eAAe;;IAEf,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,yDAAgD;IAChD,wBAAwB;IACxB,4BAA4B;IAC5B,UAAU;IACV,4FAA4F;AAChG;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;IACpB,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,yBAAyB;IACzB,wCAAwC;IACxC,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;IAChC,qBAAqB;IACrB,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,2CAA2C;IAC3C,mCAAmC;IACnC,yBAAyB;IACzB,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,wCAAwC;IACxC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,mCAAmC;IACnC,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,oCAAoC;IACpC,gCAAgC;IAChC,mCAAmC;IACnC,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,wCAAwC;IACxC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,2CAA2C;IAC3C,mCAAmC;IACnC,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,yBAAyB;IACzB,wCAAwC;IACxC,gBAAgB;IAChB,yCAAyC;IACzC,oCAAoC;IACpC,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;AACrB;;;AAGA;IACI,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,4BAA4B;IAC5B,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,2BAA2B;IAC3B,gCAAgC;IAChC,wCAAwC;IACxC,gBAAgB;IAChB,wBAAwB;IACxB,sBAAsB;IACtB,kBAAkB;IAClB,oCAAoC;IACpC,gBAAgB;IAChB,qBAAqB;;AAEzB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,yDAA2C;IAC3C,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;AACd;;AAEA;;IAEI;QACI,wBAAwB;QACxB,eAAe;QACf,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;;;OAGG;;IAEH;QACI,UAAU;IACd;;AAEJ;;;;;AAKA;IACI;QACI;IACJ;IACA;QACI;IACJ;AACJ","sourcesContent":["/* MOVIMENTAÇÂO CARDS */\r\n@import url('https://fonts.googleapis.com/css2?family=Cardo:wght@700&family=Inter:wght@400;600&display=swap');\r\n\r\n.homePage{\r\n    /* background-image: url('../imgs/fundoEsq1.jpg'); */\r\n    background-size: cover;\r\n    background-color: #706c6d;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.homePage .homelogo{\r\n    /* position: relative; */\r\n    min-width: 50%;\r\n    max-width: 80%;\r\n    /* top: 500px; */\r\n    margin-top: 7vh;\r\n    \r\n    margin-bottom: 20px;\r\n    align-self: center;\r\n    aspect-ratio: 350/111;\r\n    background-image: url('../imgs/logoBabitaW.svg');\r\n    background-size: contain;\r\n    background-repeat: no-repeat;\r\n    z-index: 7;\r\n    /* filter: drop-shadow(0px 0px 2px var(--white-color)) drop-shadow(0px 0px 2px #0000004a); */\r\n}\r\n\r\n.homePage .homelogo.logoAnima{\r\n    animation: logoAnimation 0.5s ease-out 0.5s forwards;\r\n}\r\n\r\n.celular{\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    height: 98vh;\r\n    aspect-ratio: 1/2.07;\r\n    background-size: contain;\r\n    background-repeat: no-repeat;\r\n}\r\n\r\n.introText{\r\n    width: 90%;\r\n    text-align: center;\r\n    color: var(--white-color);\r\n    font-family: 'Playfair Display', 'serif';\r\n    font-weight: 600;\r\n    margin: 0 auto;\r\n    font-size: 1.3em;\r\n}\r\n\r\n.inputFiltro{\r\n    width: 60%;\r\n    height: 45px;\r\n    border-radius: 5px;\r\n    color: var(--escuro-cinza-color);\r\n    margin: 20px 0 20px 0;\r\n    font-family: 'Simonetta', 'serif';\r\n    font-weight: 500;\r\n    text-align: center;\r\n    font-size: 1.5em;\r\n}\r\n\r\n.btnBuscar {\r\n    width: 40%;\r\n    background-color: var(--escuro-cinza-color);\r\n    box-shadow: 0 4px 6px 1px #FFFFFF4d;\r\n    color: var(--white-color);\r\n    border: 3px solid var(--white-color);\r\n    padding: 10px 20px;\r\n    font-size: 16px;\r\n    cursor: pointer;\r\n    border-radius: 5px;\r\n    transition: all 0.3s ease;\r\n    font-family: 'Playfair Display', 'serif';\r\n    font-weight: 600;\r\n    text-align: center;\r\n}\r\n\r\n.btnBuscar:hover {\r\n    background-color: var(--white-color);\r\n    box-shadow: 0 6px 8px 2px #4a45474d;\r\n    color: var(--escuro-cinza-color);\r\n}\r\n\r\n.divisor{\r\n    width: 80%;\r\n    height: 5px;\r\n    border-radius: 15px;\r\n    background-color: var(--white-color);\r\n    margin: 30px 0 15px 0;\r\n}\r\n\r\n.vendList{\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    width: 85%;\r\n}\r\n\r\n.proxVend {\r\n    width: 40%;\r\n    background-color: var(--white-color);\r\n    color: var(--escuro-cinza-color);\r\n    box-shadow: 0 6px 8px 2px #4a45474d;\r\n    border: 3px solid var(--white-color);\r\n    padding: 10px 20px;\r\n    font-size: 16px;\r\n    cursor: pointer;\r\n    border-radius: 5px;\r\n    transition: all 0.3s ease;\r\n    font-family: 'Playfair Display', 'serif';\r\n    font-weight: 600;\r\n    text-align: center;\r\n}\r\n\r\n.proxVend:hover {\r\n    background-color: var(--escuro-cinza-color);\r\n    box-shadow: 0 4px 6px 1px #FFFFFF4d;\r\n    color: var(--white-color);\r\n}\r\n\r\n.btnBuscarCep{\r\n    margin-top: 15px;\r\n}\r\n\r\n.vendedoraCard{\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    width: 95%;\r\n    text-align: center;\r\n    color: var(--black-color);\r\n    font-family: 'Playfair Display', 'serif';\r\n    font-weight: 500;\r\n    /*border: 2px dashed var(--white-color);*/\r\n    background-color: var(--white-color);\r\n    border-radius: 5px;\r\n    padding: 15px 5px;\r\n    margin: 15px auto;\r\n}\r\n\r\n\r\n.vendedoraCard .textInfoRevend{\r\n    width: 80%;\r\n    margin: 2px 0;\r\n    text-align: left;\r\n    padding-left: 10px;\r\n}\r\n\r\n.vendedoraCard .textInfoRevend strong{\r\n    color: var(--white-color);\r\n    font-family: 'Cardo', 'serif'\r\n}\r\n\r\n.revendFoto{\r\n    width: 20%;\r\n    aspect-ratio: 1/1;\r\n    background-repeat: no-repeat;\r\n    background-size: cover;\r\n    background-position: center;\r\n    border-radius: 50%;\r\n}\r\n\r\n.wpRevend{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 40px;\r\n    aspect-ratio: 1/1;\r\n    background-color: #dddddd55;\r\n    color: var(--escuro-cinza-color);\r\n    font-family: 'Playfair Display', 'serif';\r\n    font-weight: 600;\r\n    padding: 6px 6px 6px 6px;\r\n    margin: 20px 0px 5px 0;\r\n    border-radius: 50%;\r\n    border: 2px solid var(--black-color);\r\n    font-size: 1.2em;\r\n    text-decoration: none;\r\n    \r\n}\r\n\r\n.wpRevend .wpImage{\r\n    width: 30px;\r\n    aspect-ratio: 1/1;\r\n    background-image: url('../imgs/wpIcon.png');\r\n    background-size: contain;\r\n    background-repeat: no-repeat;\r\n}\r\n\r\n.topRevend{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 95%;\r\n}\r\n\r\n@media(max-width: 767px){\r\n\r\n    .homePage .homelogo {\r\n        /* position: absolute; */\r\n        min-width: 50vw;\r\n        max-width: 50vw;\r\n        margin-top: 5px;\r\n    }\r\n\r\n    .introText{\r\n        width: 98%;\r\n        font-size: 1.1em;\r\n    }\r\n\r\n    .vendList{\r\n        width: 100%;\r\n    }\r\n\r\n    .vendedoraCard .textInfoRevend div{\r\n        width: 100%;\r\n    }\r\n\r\n    /* .wpRevend{\r\n        width: 80%;\r\n        font-size: 1.0em;\r\n    } */\r\n\r\n    .proxVend {\r\n        width: 70%;\r\n    }\r\n\r\n}\r\n\r\n\r\n\r\n\r\n@keyframes logoAnimation {\r\n    0%{\r\n        transform: translateX(200%)\r\n    }\r\n    100%{\r\n        transform: translateX(0%)\r\n    }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
